<template>
  <div :class="classes">
    <pt-page-title title="知识库详情"></pt-page-title>
    <div v-if="corpus">
      <pt-sub-title title="检测项知识信息"></pt-sub-title>
      <pt-form-item class="special" label="所属检测项:" :labelWidth="labelWidth" :lineHeight="lineHeight">
        <router-link :to="{ name: 'detection-detail', params: { id: corpus.detectionItemId }}">{{corpus.detectionItemNameCn || corpus.chineseName}}</router-link>
        <!-- <span>(点击跳转到检测项详情页)</span> -->
      </pt-form-item>
      <!-- <pt-form-item class="special" label="英文名称:" :labelWidth="labelWidth" :lineHeight="lineHeight">
        <span>{{corpus.englishName}}</span>
      </pt-form-item> -->
      <pt-form-item class="special" label="所属知识库:" :labelWidth="labelWidth" :lineHeight="lineHeight">
        <span>{{corpus.corpusName || corpus.chineseName }}</span>
      </pt-form-item>
      <pt-form-item class="special" label="报告展示名称:" :labelWidth="labelWidth" :lineHeight="lineHeight">
        <span>{{ corpus.chineseName }}</span>
      </pt-form-item>
      <pt-form-item class="special" label="常用药品名:" :labelWidth="labelWidth" :lineHeight="lineHeight">
        <span>{{ corpus.commonDrugsName }}</span>
      </pt-form-item>
      <pt-form-item class="special" label="类型:" :labelWidth="labelWidth" :lineHeight="lineHeight">
        <span>{{corpus.type}}</span>
      </pt-form-item>
      <template v-if="corpus.risk || corpus.concern || corpus.normal">
        <pt-sub-title title="疾病风险提示建议"></pt-sub-title>
        <pt-form-item class="special" label="高风险提示建议:" :labelWidth="labelWidth" :lineHeight="lineHeight">
          <span>{{corpus.risk}}</span>
        </pt-form-item>
        <pt-form-item class="special" label="中风险提示建议:" :labelWidth="labelWidth" :lineHeight="lineHeight">
          <span>{{corpus.concern}}</span>
        </pt-form-item>
        <pt-form-item class="special" label="低风险提示建议:" :labelWidth="labelWidth" :lineHeight="lineHeight">
          <span>{{corpus.normal}}</span>
        </pt-form-item>
      </template>
      <pt-sub-title title="检测项知识详情"></pt-sub-title>
      <div v-for="(level1, index) in corpus.contents" :key="index">
        <el-collapse v-model="activeNames">
          <el-collapse-item :title="level1.header" :name="index">
            <div v-html="replaceEnter(level1.description)"></div>
            <!-- 富文本表格 -->
            <template v-if="level1.richTextContent">
              <div class="table" v-html="replaceEnter(level1.richTextContent)"></div>
            </template>
            <el-collapse v-model="activeNames" v-for="(level2, index_sec) in level1.contents" :key="index_sec">
              <el-collapse-item :title="level2.header +'（'+ (level2.hasIcon == true ? '有' : '无')+'图标）'" :name="index+'_'+index_sec">
                <div v-html="replaceEnter(level2.description)"></div>
                <!-- 富文本表格 -->
                <template v-if="level2.richTextContent">
                  <div class="table" v-html="replaceEnter(level2.richTextContent)"></div>
                </template>
                <!-- 表格描述 -->
                <template v-if="corpus.agentId=='vcanClinic'">
                  <div v-for="(level3, index_third) in level2.contents" :key="index_third" >
                    <p v-html="replaceEnter(level3.description)"></p>
                  </div>
                </template>
                <template v-else>
                  <el-collapse v-model="activeNames" v-for="(level3, index_third) in level2.contents" :key="index_third">
                      <el-collapse-item :title="level3.header +'（'+ (level3.hasIcon == true ? '有' : '无')+'图标）'" :name="index+'_'+index_sec+'_'+index_third">
                      <div v-html="replaceEnter(level3.description)"></div>
                    </el-collapse-item>
                  </el-collapse>
                </template>
              </el-collapse-item>
            </el-collapse>
          </el-collapse-item>
        </el-collapse>
      </div>
    </div>
    <!-- 按钮 -->
    <el-button type="primary" @click="goEdit(corpus)">编辑</el-button>
  </div>
</template>

<script>
// 组件class前缀
import { formatDetectionCategory } from 'enumeration/lab-order.js'
const prefixCls = 'pt-detection-corpus-detail'

export default {
  name: 'pt-detection-corpus-detail',
  computed: {
    classes () {
      return `${prefixCls}`
    }
  },
  props: {
    corpus: {
      type: Object,
      default: () => {}
    }
  },
  data () {
    return {
      labelWidth: '100px',
      lineHeight: '26',
      activeNames: [0]
    }
  },
  watch: {
    corpus (val) {
      this.getActiveNames()
    }
  },
  methods: {
    formatDetectionCategory,
    replaceEnter (data) {
      // var reg = new RegExp('/\n', 'g')
      return data.replace(/[\r\n]/g, '<br>')
    },
    getActiveNames () {
      var arr = []
      this.corpus.contents.forEach((level1, index) => {
        arr.push(index)
        level1.contents.forEach((level2, indexSec) => {
          arr.push(index + '_' + indexSec)
          level2.contents.forEach((level3, indexThird) => {
            arr.push(index + '_' + indexSec + '_' + indexThird)
          })
        })
      })
      this.activeNames = arr
    },
    goEdit (data) {
      this.$router.push({ name: 'detection-corpus-update', params: { id: data.id } })
    }
  },
  created () {
    if (this.corpus) {
      this.getActiveNames()
    }
  }
}
</script>

<style lang="less">
@import '~less/var.less';
/* 已启用css module， template中请使用$style.className添加class */
/* 务必遵循css BEM原则 */
.pt-detection-corpus-detail{
  .special >span{
    color:@mainColor;
  }
  .el-collapse{
    margin-bottom: 20px;
    margin-left: 20px;
    padding-left: 20px;
    border: 0.01rem solid #ebeef5;
	}
	.table{
		>br{
			display: none;
		}
	}
}
</style>
